import { AfterViewInit, Component, Input, OnDestroy, OnInit } from "@angular/core";

import { TypeSystem } from "../../../support/type-system.support";
import { AlertSeverity, toAlertSeverityString } from "./alert-severity.enum";

	/**
	 * @description
	 *	Mensaje de alerta con nivel de severidad customizable.
	 */

@Component({
	selector: "x-alert",
	styleUrls: ["./alert.component.scss"],
	templateUrl: "./alert.component.html"
})
export class AlertComponent implements AfterViewInit, OnDestroy, OnInit {

	@Input()
	public message: string;

	@Input()
	public severity: AlertSeverity;

	@Input()
	public title: string;

	public constructor() {
	}

	public ngOnInit(): void {
		this.message = TypeSystem.orElse(this.message, "Origen de la alerta desconocida.");
		this.severity = TypeSystem.orElse(this.severity, AlertSeverity.Warning);
		this.title = TypeSystem.orElse(this.title, toAlertSeverityString(this.severity));
	}

	public ngAfterViewInit(): void {
	}

	public ngOnDestroy(): void {
	}
}
